module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/sort-3-bca3f8d91c7cd4507043dcede8fbe50a.svg";